export const link = {
  github: '',
  dribble: '',
  linkedin: '',
  twitter: '',
};
